// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pseudo-link{border:0;background-color:transparent;padding:0;font-family:inherit;text-decoration:none;color:inherit;color:#3d70b2;transition:color .3s;border-bottom:1px dashed currentColor;transition:border-bottom-color .3s}.pseudo-link:not(:disabled){cursor:pointer}.pseudo-link._tap,.pseudo-link:hover{color:#4186df}.pseudo-link._tap,.pseudo-link:hover:not(._mobile){border-bottom-color:transparent}", ""]);
// Exports
module.exports = exports;
